// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__RW3Fh","log":"ModalInventoryLogs_log__2ZG_i","date":"ModalInventoryLogs_date__2inEA","userName":"ModalInventoryLogs_userName__2xEIK"};